// The add / save / delete handlers a LogbookSummary card needs, factored out
// of ItemLogbooks so the cross-item Trips page can render the same cards
// without inheriting the rest of that component (the Add Logbook button, the
// empty-state card, the import modal -- none of which belong there).
//
// A card owns nothing: it reads its entries off `logbook.completedTasks.items`
// and calls back when the list changes. These handlers rewrite that list and
// then call `commit()`, which is the caller's cue to re-render with a fresh
// object identity -- an in-place mutation alone would leave the card showing
// stale rows, since the save usually lands after the modal-close render.
//
//   logbook - the logbook the card is showing
//   commit  - re-render the owner of `logbook` (clone the item / section)
//   onAll   - "See All" handler (navigation is the caller's business)
export function makeLogbookSummaryCallbacks({ logbook, commit, onAll }) {
  function replaceEntries(entries) {
    logbook.completedTasks = { items: entries };
    commit();
  }

  return {
    onAll,
    onAdded: (entry) => replaceEntries([entry, ...(logbook.completedTasks?.items ?? [])]),
    onSaved: (entry) => replaceEntries(
      (logbook.completedTasks?.items ?? []).map((e) => (e.id === entry.id ? entry : e))
    ),
    onDelete: (entry) => replaceEntries(
      (logbook.completedTasks?.items ?? []).filter((e) => e.id !== entry.id)
    ),
  };
}
